import { Component } from '@angular/core';
import {AppSettings} from '../../../shared/app-settings';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">Copyright © 2020 <b><a href="http://www.dfrc.com.sg" target="_blank">DFRC</a></b></span>
    <span > {{version}} </span>
  `,
})
export class FooterComponent {
  version: string = AppSettings.version;
}
